// Keep these values in sync with PendingAdd.php.
export const MULTI_ACCOUNT_LOGIN_MODES = {
    ADD_PROFILE: 'add-profile',
    SWITCHING: 'switching',
} as const;

export type MultiAccountLoginMode =
    (typeof MULTI_ACCOUNT_LOGIN_MODES)[keyof typeof MULTI_ACCOUNT_LOGIN_MODES];

export function getMultiAccountLoginMode(): MultiAccountLoginMode | null {
    const mode =
        document.querySelector<HTMLElement>('#pre-auth-react-mount')?.dataset.multiAccountLoginMode;

    return mode === MULTI_ACCOUNT_LOGIN_MODES.ADD_PROFILE ||
        mode === MULTI_ACCOUNT_LOGIN_MODES.SWITCHING
        ? mode
        : null;
}
